module.exports = __webpack_public_path__ + "static/media/Eliminar.78ccbb62.svg";